// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3ZkUn","search":"Settings_search__3fbbQ","filter":"Settings_filter__3ef_q"};